module.exports = __webpack_public_path__ + "img/teacher_competency_and_enhancement_program.f99118de.svg";